import { render, staticRenderFns } from "./NumberConfig.vue?vue&type=template&id=9697fc9a&scoped=true"
import script from "./NumberConfig.vue?vue&type=script&lang=js"
export * from "./NumberConfig.vue?vue&type=script&lang=js"
import style0 from "./NumberConfig.vue?vue&type=style&index=0&id=9697fc9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9697fc9a",
  null
  
)

export default component.exports